import { createContext, useContext, useState } from "react";

type DesignOptionsContextType = {
  selectedTemplate: string | null;
  selectedStyle: string | null;
  selectedOrientation: string;
  selectedColors: string;
  setSelectedTemplate: (template: string) => void;
  setSelectedStyle: (style: string) => void;
  setSelectedOrientation: (orientation: string) => void;
  setSelectedColors: (colors: string) => void;
};

const DesignOptionsContext = createContext<DesignOptionsContextType | undefined>(undefined);

type DesignOptionsProviderProps = {
  children: React.ReactNode;
};

export const DesignOptionsProvider = ({ children }: DesignOptionsProviderProps) => {
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>("default");
  const [selectedStyle, setSelectedStyle] = useState<string | null>("default");
  const [selectedOrientation, setSelectedOrientation] = useState("square");
  const [selectedColors, setSelectedColors] = useState("full-color");

  const value = {
    selectedTemplate,
    selectedStyle,
    selectedOrientation,
    selectedColors,
    setSelectedTemplate,
    setSelectedStyle,
    setSelectedOrientation,
    setSelectedColors
  };

  return <DesignOptionsContext.Provider value={value}>{children}</DesignOptionsContext.Provider>;
};

export const useDesignOptions = () => {
  const context = useContext(DesignOptionsContext);
  if (context === undefined) {
    throw new Error("useDesignOptions must be used within a DesignOptionsProvider");
  }
  return context;
};
